// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"d574a052","243":"d574a052","338":"7fcce279","388":"d574a052","767":"d574a052","892":"d574a052","918":"d574a052","970":"d574a052","980":"d574a052"}[chunkId] + ".chunk.css";
};